/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-table-row-overlay',
    templateUrl: './table-row-overlay.component.html',
    styleUrls: ['./table-row-overlay.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableRowOverlayComponent implements OnInit {

    @Input() message: string;
    @Input() overlayClass: string;

    constructor() {
    }

    ngOnInit(): void {
    }

    /** Sets the overlay class
     * If no overlay class is passed through the {@link overlayClass} a default white overlay is applied
     **/
    setOverlayClass(): string {
        return this.overlayClass ? this.overlayClass : 'overlay-white';
    }

}
